export default {
  "content": "<path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M16.688 10.5V7c0-.55-.45-1-1-1H7l9.688 9.688V13.5l2.29 2.29c.63.63 1.71.18 1.71-.71V8.91c0-.89-1.08-1.34-1.71-.71l-2.29 2.3zM3 8.327V17c0 .55.45 1 1 1h8.677L3 8.323v.004z\" clip-rule=\"evenodd\"/><path fill=\"#EA3917\" fill-rule=\"evenodd\" d=\"M2.73 4.73a.842.842 0 011.191 0l14.316 14.316a.842.842 0 11-1.19 1.191L2.73 5.921a.842.842 0 010-1.19z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "none",
    "viewBox": "0 0 24 24"
  }
};